module.exports = __webpack_public_path__ + "img/Node.js.b8bf7f8.svg";